export const TOOLTIP_MAX_WIDTH = {
  xs: 280,
  sm: 320,
  md: 360,
  lg: 380,
  xl: 420
};
export const TOOLTIP_SIMPLE_PADDING = '16px';
export const TOOLTIP_MULTILINE_PADDING = '4px 8px';
export const TOOLTIP_TRIGGERS_VARIANTS = ['hover', 'click', 'enter'];